// extracted by mini-css-extract-plugin
module.exports = {"loadingState":"LoadingState_loadingState__88E7Q","rotate":"LoadingState_rotate__gNt_E","variant":"LoadingState_variant__NnhB_"};